/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'auditing': {
    width: 150,
    height: 150,
    viewBox: '0 0 150 150',
    data: '<path pid="0" d="M75.5 128C46.505 128 23 104.495 23 75.5S46.505 23 75.5 23 128 46.505 128 75.5 104.495 128 75.5 128zM65.382 45c-5.222 0-10.453 1.988-14.424 5.958-7.944 7.944-7.944 20.883 0 28.827 7.158 7.158 18.381 7.882 26.34 2.137l2.034 2.034a1.969 1.969 0 0 0 0 2.794l17.65 17.67c.37.37.873.58 1.397.58a1.98 1.98 0 0 0 1.397-.58l4.644-4.664c.37-.37.58-.874.58-1.398a1.98 1.98 0 0 0-.58-1.397L86.77 79.312a1.969 1.969 0 0 0-2.794 0l-2.055-2.055c5.725-7.958 5.013-19.149-2.137-26.299C75.814 46.988 70.602 45 65.381 45zm.129 4c4.215 0 8.418 1.616 11.646 4.844a16.45 16.45 0 0 1 0 23.313 16.451 16.451 0 0 1-23.314 0 16.474 16.474 0 0 1 0-23.333C57.072 50.595 61.295 49 65.51 49zm19.387 34L100 98.102 98.102 100 83 84.898 84.898 83z" _fill="#C4FFF9" fill-rule="nonzero"/>'
  }
})
